import { render } from "./BuilderDisabled.vue?vue&type=template&id=20cf44d0"
import script from "./BuilderDisabled.vue?vue&type=script&lang=js"
export * from "./BuilderDisabled.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__